import { render } from "./CancelledAuctionsView.vue?vue&type=template&id=31603dca&scoped=true&ts=true"
import script from "./CancelledAuctionsView.vue?vue&type=script&lang=ts"
export * from "./CancelledAuctionsView.vue?vue&type=script&lang=ts"

import "./CancelledAuctionsView.vue?vue&type=style&index=0&id=31603dca&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31603dca"]])

export default __exports__